import { useUnit } from 'effector-react'
import ContentLoader from 'react-content-loader'
import { $theme } from 'shared/theme'

type Props = {
  className?: string
}

export default function CourseContentLoader({ className }: Props) {
  const theme = useUnit($theme)
  const backgroundColor = theme === 'dark' ? '#202020' : '#C6D2DD'
  const foregroundColor = theme === 'dark' ? '#646464' : '#F6F9FC'

  return (
    <ContentLoader
      className={className}
      speed={2}
      viewBox="0 0 1785 250"
      backgroundColor={backgroundColor}
      foregroundColor={foregroundColor}
    >
      <rect x="200" y="90" rx="5" ry="5" width="600" height="60" />
      <rect x="200" y="155" rx="25" ry="25" width="250" height="50" />
      <circle cx="1575" cy="110" r="20" />
    </ContentLoader>
  )
}
